import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-580263ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "picture-preview" }
const _hoisted_2 = { class: "picture-preview-header" }
const _hoisted_3 = { class: "ai-info-text" }
const _hoisted_4 = { class: "ai-info-text-value" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-basket-shopping-plus" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "options-pannel" }
const _hoisted_8 = { class: "title-bar" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-arrow-left" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "title-text" }
const _hoisted_12 = { class: "scroll-view-wrapper" }
const _hoisted_13 = { class: "ai-options" }
const _hoisted_14 = ["disabled", "onClick"]
const _hoisted_15 = { class: "ai-option-title" }
const _hoisted_16 = { class: "ai-option-description" }
const _hoisted_17 = {
  key: 0,
  class: "ai-option-cost"
}
const _hoisted_18 = {
  key: 1,
  class: "ai-option-group"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-arrow-right" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "save-section" }
const _hoisted_22 = { class: "cancel-section" }
const _hoisted_23 = { class: "enhance-section" }
const _hoisted_24 = ["visible"]
const _hoisted_25 = { class: "ai-info-text-value" }

import { computed, ref, watch, inject, onUnmounted, onMounted } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import displayErrorMessage, {
  displayMarkdownErrorMessage,
} from "@/utils/ErrorHandling";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { AcquaintApiNextClient } from "@/services/AcquaintApiNextClient";
import { PropertyImageType } from "acquaint-api/constants/PropertyImageType";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import AiImageDisplay from "@/components/ai/ai-image-display.vue";
import { displayCancelConfirmationWarningAlert } from "@/alerts/cancelConfirmationWarningAlert";
import moment from "moment";
import { sizes } from "@/utils/media-query";
import displayInfoToast from "@/alerts/infoToastAlert";
import { displayMarkdownQuestionAlert } from "@/alerts/questionAlert";
import { AiGeneratedImage } from "@/types/ai/AiGeneratedImage";
import { DxButton } from "devextreme-vue";
import { AiImageEnhancement } from "@/types/ai/AiImageEnhancement";
import ScrollView from "@/components/ui/scroll-view.vue";
import { useCurrentUserStore } from "@/stores/CurrentUserStore";
import { CurrentUser } from "@/types/user/CurrentUser";
import SwitchToggle from "@/components/ui/toggles/switch-toggle.vue";
import { copyBlobImageToClipboard } from "@/utils/files/BlobImageUtils";

const aiInfo = `If errors occur when enhancing, please ensure the following:

<b>Use unwatermarked images</b>: Watermarks may trigger copyright protection, which can block images from enhancing.

<b>Content should be appropriate</b>: Inappropriate content may be blocked.

You will not be charged for enhancements that cause errors.`;
const aiInfoTitle = "";

// Fetched

export default /*#__PURE__*/_defineComponent({
  __name: 'ai-image-enhancer-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The Property that the image belongs to.
   * @type {Number}
   * @required
   */
  propertyId: {
    type: Number,
    required: true,
  },
  /**
   * The index of the image that will be displayed.
   * @type {Number}
   * @required
   */
  imageToDisplay: {
    type: Number,
    required: true,
  },
  /**
   * If the image is allowed to be saved as new, instead of replacing the original
   * @type {Boolean}
   * @required
   */
  allowSaveAsNew: {
    type: Boolean,
    default: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /**
   * Triggered when the Save or Replace buttons are clicked
   */
  "aiResponseSaved",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

// Static
const apiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const apiNextClient = inject("AcquaintApiNextClient") as AcquaintApiNextClient;
const imageToDisplay = ref(0);
const currentUserStore = useCurrentUserStore();
const currentUser = ref<CurrentUser>();
const aiCredits = ref<undefined | number>();
const prompts = ref<AiImageEnhancement[]>([]);
const originalImageAsURL = ref("");

// Dynamic
const awaitingResultsQueue = ref<number[]>([]);
const requestedThisSession = ref(false);
const awaitingResult = ref(false);
const includeAiWatermark = ref(true);
const selectedPromptId = ref(-1);
const aiGeneratedImages = ref<AiGeneratedImage[]>([]);
const groupPath = ref<AiImageEnhancement[]>([]);
const slideDirection = ref("forward"); // "forward" | "back" changes depending on if the user goes forward or back groups
const refreshModal = ref(0);

const currentEnhancementList = computed(() => {
  return groupPath.value[groupPath.value.length - 1]?.items ?? prompts.value;
});

const windowUrl = computed(() => window.webkitURL || window.URL);

const currentAiImage = computed(
  () => aiGeneratedImages.value[aiGeneratedImages.value.length - 1],
);

onMounted(async () => {
  currentUser.value = await currentUserStore.getCurrentUserDetails();
});

watch(
  () => showModal.value,
  async (value) => {
    if (displayCancelConfirmationModal.value || !value) {
      return;
    }
    await fetchAICredits();
    await fetchPromptOptions();

    selectedPromptId.value = -1;
    groupPath.value = [];
    imageToDisplay.value = props.imageToDisplay;
    awaitingResult.value = false;
    requestedThisSession.value = false;
    includeAiWatermark.value = true;

    const imgBlob = await fetchImageBlob();
    if (!imgBlob) return;
    originalImageAsURL.value = windowUrl.value.createObjectURL(imgBlob);
    aiGeneratedImages.value = [];
  },
);

watch(
  () => includeAiWatermark.value,
  async (value) => {
    if (!value) {
      const removeWatermarkResult = await displayMarkdownQuestionAlert(
        `<b>Important:</b> The watermark text cannot be customised or replaced.

The final image will not display that it was enhanced with AI, so it is important to thoroughly check your output for accuracy.

Do you want to continue?`,
      );
      if (!removeWatermarkResult.isConfirmed) includeAiWatermark.value = true;
    }
  },
);

watch(
  () => groupPath.value.length,
  () => {
    selectedPromptId.value = -1;
  },
);

const onAICreditsClick = async () => {
  const sitePrefix = await currentUserStore.getSitePrefix();
  const siteId = currentUser.value?.siteID ?? 0;

  const url = `https://www.acquaintcrm.co.uk/PurchaseAICredits.aspx?SitePrefix=${sitePrefix}&SiteID=${siteId}`;

  window.open(url, "_blank");
};

const fetchAICredits = async () => {
  try {
    aiCredits.value = await apiNextClient.httpGet(
      "AIResponse/GetAICreditBalance",
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    aiCredits.value = undefined;
  }
};

const fetchPromptOptions = async () => {
  try {
    prompts.value = await apiNextClient.httpGet("/ai/prompts/definitions/1");
  } catch {
    displayErrorMessage("Unable to load AI options");
  }
};

const fetchImageBlob = async (): Promise<Blob | undefined> => {
  try {
    const url =
      `app/properties/${props.propertyId}/pictures/${imageToDisplay.value}` +
      `?type=${PropertyImageType.PropertyImageWeb}`;

    return await apiClient.getFile(url); // Must return Blob
  } catch {
    displayErrorMessage("The selected image could not be found.");
    closeModal();
    return undefined;
  }
};

const fetchImageResponse = async () => {
  if (aiGeneratedImages.value.length >= 3) {
    const recursionContinueResult = await displayMarkdownQuestionAlert(
      `Results may be unpredictable or distorted after multiple AI enhancements <b style="color:#a36c1e;">(current: ${aiGeneratedImages.value.length})</b>. Are you sure you want to continue?`,
    );
    if (!recursionContinueResult.isConfirmed) return;
  }

  /*  requestedThisSession and awaitingResultsQueue are used to prevent users being returned output from previous calls to the API
      requestedThisSession makes sure the user is actually waiting for a response during the current display of the modal
      awaitingResultsQueue makes sure if the user has sent a request, that the previous response isn't treated as a response to the new request
      If not used, we could run into issues where the user requests, closes the modal, reopens it and is displayed the result from the cancelled request
  */
  awaitingResult.value = true;
  requestedThisSession.value = true;
  awaitingResultsQueue.value?.push(moment.now());

  setTimeout(() => {
    fetchAICredits();
  }, 500);

  try {
    let result: Blob;

    // If an AI image has already been generated, we use that as the basis for the new generation
    if (currentAiImage.value !== undefined) {
      result = await apiNextClient.getFileWithPostData(
        `ai/images/blob/enhance/${selectedPromptId.value}`,
        currentAiImage.value?.blob,
        false,
      );
    }
    // If no AI image exists, we use the original image taken from the property
    else {
      const request = {
        promptId: selectedPromptId.value,
        propertyId: props.propertyId,
        pictureNumber: props.imageToDisplay,
      };

      result = await apiNextClient.getFileWithPostData(
        "ai/images/property/enhance",
        request,
      );
    }

    awaitingResultsQueue.value?.shift();
    if (
      awaitingResultsQueue.value?.length ||
      // @ts-expect-error: The requestedThisSession value can change during the course of the await, which isn't accounted for by typescript
      requestedThisSession.value === false
    ) {
      return;
    }

    // We grab the watermarked image here to reduce calls later, and we can hide the time to get the result behind the generation time
    const watermarkedImage = await getAiWatermarkedBlob(result);
    const aiImage = {
      blob: result,
      url: windowUrl.value.createObjectURL(result),
      watermarkedBlob: watermarkedImage,
      watermarkedUrl: windowUrl.value.createObjectURL(watermarkedImage),
    };
    aiGeneratedImages.value.push(aiImage);
    selectedPromptId.value = -1;
    awaitingResult.value = false;
    await fetchAICredits();
  } catch (e: any) {
    displayMarkdownErrorMessage(`There was an error enhancing the image. Click the <i class='far fa-circle-info'></i> for potential causes and solutions.
    
Your credits have been refunded.`);
    awaitingResult.value = false;
    closeModal();
  }
};

const onBackButtonClick = () => {
  slideDirection.value = "back";
  groupPath.value.pop();
};

const onPromptButtonClick = (option: AiImageEnhancement) => {
  slideDirection.value = "forward";
  if (option.items.length) groupPath.value.push(option);
  else selectedPromptId.value = option.id;
};

const getCurrentAiImageFile = () => {
  const blob = getCurrentAiImageBlob();

  if (!blob) return;
  const file = new File([blob], "", { type: "image/jpeg" });
  return file;
};

const getCurrentAiImageBlob = (): Blob | undefined => {
  if (!currentAiImage.value) return undefined;

  return includeAiWatermark.value
    ? currentAiImage.value.watermarkedBlob
    : currentAiImage.value.blob;
};

const getAiWatermarkedBlob = async (blob: Blob | undefined) => {
  return await apiNextClient.getFileWithPostData(
    `ai/images/watermark`,
    blob,
    false,
  );
};

const postAIImageAsReplacement = async () => {
  try {
    await apiClient.uploadFile(
      `app/properties/pictureenhanced/${props.propertyId}/${props.imageToDisplay}`,
      getCurrentAiImageFile(),
    );
    emit("aiResponseSaved", false);
    return true;
  } catch (err) {
    displayErrorMessage("Image could not be saved");
    return false;
  }
};

// Replaces the original image within the property's images
const aiImageReplace = async () => {
  await postAIImageAsReplacement();
  closeModal();
};

const postAIImageAsNew = async () => {
  try {
    await apiClient.uploadFile(
      `app/properties/${props.propertyId}/pictures`,
      getCurrentAiImageFile(),
    );
    emit("aiResponseSaved", true);
    return true;
  } catch (err) {
    displayErrorMessage("Image could not be saved");
    return false;
  }
};

// Saves the AI generation as a new image
const aiImageSaveNew = async () => {
  await postAIImageAsNew();
  closeModal();
};

const copyImage = async () => {
  const blob = getCurrentAiImageBlob();
  if (blob) copyBlobImageToClipboard(blob, false);
  displayInfoToast("AI Enhanced image copied to clipboard!", 4000);
};

// Cannot just use the url of the current AI image, as after the first generation, it points to a blob which downloaded as a file with no extension
const downloadImage = () => {
  const file = getCurrentAiImageFile();

  if (!file) return;

  const url = URL.createObjectURL(file);

  const link = document.createElement("a");
  link.href = url;
  const watermarkText = includeAiWatermark.value ? "-watermarked" : "";
  link.download = `ai-enhanced-image-${props.propertyId}-${props.imageToDisplay}${watermarkText}`;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};

// Discards the AI generation and resets the modal to its state before the user clicked generate
const undoEnhancement = async () => {
  displayCancelConfirmationWarningAlert(
    "Are you sure you want to undo this enhancement? You will lose an AI generation you have spent credits on without saving.",
  ).then((result) => {
    if (result.isConfirmed) {
      aiGeneratedImages.value.pop();
      selectedPromptId.value = -1;
    }
  });
};

const currentSlotName = computed(() => {
  const screenSizes = sizes();
  return screenSizes["screen-x-small"] ? "content" : "non-scrollable-content";
});

const layoutClass = (baseLayout: string) => {
  let layout = baseLayout;
  const screenSizes = sizes();
  if (screenSizes["screen-x-small"]) {
    layout += " is-x-small";
  }

  if (currentAiImage.value && currentAiImage.value.url !== "") {
    layout += " image-generated";
  }

  return layout;
};

const getOptionClass = (option: any) => {
  let optionClass = "ai-option-btn";

  if (selectedPromptId.value === option.id) optionClass += " selected";

  optionClass += getHighlightClass(option);

  return optionClass;
};

const getHighlightClass = (option: any) => {
  switch (option.highlightType) {
    case 1:
      return " highlight featured-highlight";
    case 2:
      return " highlight new-highlight";
    case 3:
      return " highlight most-used-highlight";
    default:
      return "";
  }
};

const getHighlightText = (option: any) => {
  switch (option.highlightType) {
    case 1:
      return "Featured";
    case 2:
      return "New";
    case 3:
      return "Most Used";
    default:
      return "";
  }
};

const currentAiImageUrl = computed(() => {
  if (!currentAiImage.value) return "";
  return includeAiWatermark.value
    ? currentAiImage.value.watermarkedUrl
    : currentAiImage.value.url;
});

const displayCancelConfirmationModal = computed(
  () =>
    currentAiImage.value !== undefined ||
    awaitingResult.value ||
    selectedPromptId.value >= 0,
);

const optionsTitleText = computed(() => {
  return (
    groupPath.value[groupPath.value.length - 1]?.title ?? "AI Enhancements"
  );
});

const cancelConfirmationModalText = computed(() => {
  if (currentAiImage.value !== undefined || awaitingResult.value) {
    return "If you close now, you will lose progress on an AI generation you have spent credits on without saving. Are you sure?";
  } else {
    return "Are you sure you want to cancel?";
  }
});

onUnmounted(() => {
  // To ensure the pictures are not left hanging in browser memory, call revokeObjectUrl to delete the cached images
  if (originalImageAsURL.value != "") {
    windowUrl.value.revokeObjectURL(originalImageAsURL.value);
  }
  if (currentAiImage.value !== undefined) {
    windowUrl.value.revokeObjectURL(currentAiImage.value.url);
    windowUrl.value.revokeObjectURL(currentAiImage.value.watermarkedUrl);
  }
});

const closeModal = () => {
  awaitingResult.value = false;
  requestedThisSession.value = false;
  originalImageAsURL.value = "";
  aiGeneratedImages.value = [];
  selectedPromptId.value = -1;
  showModal.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    key: refreshModal.value,
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showModal).value = $event)),
    title: "AI Image Enhancement",
    width: _unref(ModalWidth).Large,
    showCloseConfirmationPrompt: displayCancelConfirmationModal.value,
    "custom-close-confirmation-text": cancelConfirmationModalText.value,
    "close-confirmation-is-warning": 
      currentAiImage.value !== undefined || awaitingResult.value
    ,
    "help-page": "ai-photo-enhancement",
    "info-popup": aiInfo,
    "info-popup-title": aiInfoTitle,
    onCancelPromptAccepted: closeModal
  }, {
    [currentSlotName.value]: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(layoutClass('ai-base-layout'))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_3, [
                _createTextVNode("Credits Remaining: "),
                _createElementVNode("span", _hoisted_4, _toDisplayString(aiCredits.value?.toString() ?? "0"), 1)
              ]),
              _createElementVNode("button", {
                class: "ai-buy-button",
                title: "Buy Credits",
                onClick: onAICreditsClick
              }, _hoisted_6)
            ]),
            _createElementVNode("div", null, [
              _createVNode(SwitchToggle, {
                modelValue: includeAiWatermark.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((includeAiWatermark).value = $event)),
                label: "Include AI watermark",
                "read-only": false,
                "margin-bottom": "0"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createVNode(AiImageDisplay, {
            originalImageAsURL: originalImageAsURL.value,
            aiImageAsURL: currentAiImageUrl.value,
            "waiting-for-ai-api": awaitingResult.value,
            "display-watermark": includeAiWatermark.value,
            "max-image-height": "50vh",
            height: "50vh",
            onCopyImage: copyImage,
            onDownloadImage: downloadImage,
            onUndoEnhancement: undoEnhancement
          }, null, 8, ["originalImageAsURL", "aiImageAsURL", "waiting-for-ai-api", "display-watermark"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (groupPath.value.length)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "back-arrow",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (onBackButtonClick()))
                }, _hoisted_10))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_11, _toDisplayString(optionsTitleText.value), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(ScrollView, { "show-scrollbar": "never" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_Transition, { name: slideDirection.value }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock("div", {
                        key: groupPath.value.length,
                        class: "options-container"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentEnhancementList.value, (option) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: option.id,
                            class: _normalizeClass(getOptionClass(option)),
                            disabled: 
                        (aiCredits.value! < option.creditCost || awaitingResult.value) &&
                        !option.items.length
                      ,
                            onClick: ($event: any) => (onPromptButtonClick(option))
                          }, [
                            _createElementVNode("div", _hoisted_15, _toDisplayString(option.title), 1),
                            _createElementVNode("div", _hoisted_16, _toDisplayString(option.description), 1),
                            (option.creditCost > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(option.creditCost) + " credits ", 1))
                              : _createCommentVNode("", true),
                            (option.items.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                              : _createCommentVNode("", true),
                            (option.highlightType)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 2,
                                  class: _normalizeClass(["ai-highlight-badge", getHighlightClass(option)])
                                }, _toDisplayString(getHighlightText(option)), 3))
                              : _createCommentVNode("", true)
                          ], 10, _hoisted_14))
                        }), 128))
                      ]))
                    ]),
                    _: 1
                  }, 8, ["name"])
                ])
              ]),
              _: 1
            })
          ])
        ])
      ], 2),
      _createElementVNode("section", {
        class: _normalizeClass(layoutClass('ai-footer-container'))
      }, [
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_unref(DxButton), {
            visible: currentAiImage.value !== undefined,
            text: "Replace Image",
            onClick: aiImageReplace,
            disabled: awaitingResult.value
          }, null, 8, ["visible", "disabled"]),
          _createVNode(_unref(DxButton), {
            visible: currentAiImage.value !== undefined,
            text: "Add as New",
            onClick: aiImageSaveNew,
            disabled: awaitingResult.value || !props.allowSaveAsNew
          }, null, 8, ["visible", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_unref(DxButton), {
            visible: currentAiImage.value === undefined,
            text: "Cancel",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (showModal.value = false))
          }, null, 8, ["visible"])
        ]),
        _createElementVNode("div", _hoisted_23, [
          (currentAiImage.value !== undefined)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["ai-info-text", { warning: aiGeneratedImages.value.length >= 3 }])
              }, [
                _createElementVNode("i", {
                  class: "fa-solid fa-triangle-exclamation",
                  visible: aiGeneratedImages.value.length >= 3
                }, null, 8, _hoisted_24),
                _createTextVNode(" AI Enhancements: "),
                _createElementVNode("span", _hoisted_25, _toDisplayString(aiGeneratedImages.value.length), 1)
              ], 2))
            : _createCommentVNode("", true),
          _createVNode(_unref(DxButton), {
            text: "Enhance Image",
            onClick: fetchImageResponse,
            disabled: aiCredits.value == 0 || selectedPromptId.value < 0 || awaitingResult.value,
            icon: "fa-solid fa-wand-magic-sparkles"
          }, null, 8, ["disabled"])
        ])
      ], 2)
    ]),
    _: 2
  }, 1032, ["modelValue", "width", "showCloseConfirmationPrompt", "custom-close-confirmation-text", "close-confirmation-is-warning"]))
}
}

})